<template>
  <div class="container-index">
    <div v-if="!isLoading" class="mb-3">
      <b-dropdown
      id="language_select"
      :text="languages[locale]"
      variant="primary"
      >
      <b-dropdown-item
          v-for="code in languageCodeSupport"
          :key="code"
          @click="changeLanguage(code)"
      >
          {{ languages[code] }}
      </b-dropdown-item>
      </b-dropdown>
    </div>
    <template v-if='isLoading'>
      <div class = loading-container></div>
    </template>
    <template v-else-if="myPage.isDeleted">
      <div class="card">
        <p class="title">{{ facilityName }}</p>
        <div class="cancel-text">
          <p>{{ $t("mypage.cancel-message-1") }}</p>
          <p>{{ $t("mypage.cancel-message-2") }}<br>{{ $t("mypage.cancel-message-3") }}</p>
          <p>{{ $t("mypage.cancel-message-4") }}<br>{{ $t("mypage.cancel-message-5") }}</p>
        </div>
      </div>
      <p style="margin-bottom: 100%;"></p>
    </template>
    <template v-else>
      <div class="text-one" v-html="myPageA">
      </div>
      <div class="card">
        <div class="pc-card-content">
          <p class="title">{{ facilityName }}</p>
          <p class="checkin">
            <img :src ="require('@/assets/img/check_in.svg')"/>{{ $t("mypage.check-in") }}
            <span>{{ myPage.checkinDate }}</span>
          </p>
          <p class="checkout">
            <img :src ="require('@/assets/img/check_out.svg')"/>{{ $t("mypage.check-out") }}
            <span>{{ myPage.checkoutDate }}</span>
          </p>

          <p class="qr-instruction">
          {{ $t("mypage.qr-instruction") }}
          </p>

          <!-- QR拡大ボタン -->
          <div class="qr-button-container">
            <button type="button" class="btn btn-primary" @click="showModal = true">
              <i class="fas fa-search-plus"></i>
              {{ $t("mypage.qr-button") }}
            </button>
          </div>

          <!-- QRコード画像の表示 -->
          <div class="qr-section">
            <div class="qr-container">
              <img class="qr-code" :src="myPage.qrCode" />
            </div>
            <div class="text-three text-three-mobile" v-html="myPageC"></div>
          </div>
        </div>
        <div class="text-three text-three-pc" v-html="myPageC"></div>

        <!-- カスタムモーダル -->
        <div v-if="showModal" class="custom-modal" @click.self="showModal = false">
          <div class="modal-content">
            <div class="qr-code-container">
              <span class="close-btn" @click="showModal = false">×</span>
              <img :src="myPage.qrCode" class="enlarged-qr-code" />
            </div>
          </div>
        </div>
        <p class="checkin-pc">
          <img :src ="require('@/assets/img/check_in.svg')"/>{{ $t("mypage.check-in") }}
          <span>{{ myPage.checkinDate }}</span>
        </p>
        <p class="checkout-pc">
          <img :src ="require('@/assets/img/check_out.svg')"/>{{ $t("mypage.check-out") }}
          <span>{{ myPage.checkoutDate }}</span>
        </p>
        <p class="qr-text">{{ $t("mypage.qr-text") }}</p>
      </div>

      <div class="buttons">
        <button v-for="link in sortedLinks" :key="link.label" class="btn" style='display: flex; position: relative;'@click="navigateTo(link.url)">
          <div class="btn-filter">
          </div>
          <!-- デフォルトアイコン -->
          <div v-if="!link.label.includes('option_icon')" style="display: flex; align-items: center;" class="custom-img-container">
            <img :src="link.icon" class="img-fluid icon-img" alt="icon" />
            <div class="btn-text-overlay" >
              <p>{{ link.text }}</p>
            </div>
          </div>

          <!-- オプションアイコン -->
          <div v-if="link.image" class="custom-img-container-add">
            <img :src="link.image" class="custom-img-add" style='width: 100%; height: auto;background-color: white;' alt="image" />
            <div class="btn-text-overlay-add">
              <p style='max-width: 160px;'>{{ link.text }}</p>
            </div>
          </div>
        </button>
      </div>

      <hr class="top">
      <div class="text-two" v-html="myPageB"></div>
      <hr class="bottom">
    </template>
  </div>
</template>

<script>
import myPageApi from '@/api/mypage/';
import iconApi from '@/api/icon';
import settingsApi from "@/api/settings";
import scrollers from "@/mixins/scrollers";
import { mapState, mapGetters} from "vuex";
import facilitiesApi from "@/api/facilities";
import { languageMaps } from "@/utils/mockups/language-options";
import translation from "@/mixins/translation";

const defaultMessageKeys = {
  A: ["mypage.optional-text-1-1", "mypage.optional-text-1-2", "mypage.optional-text-1-3"],
  B: ["mypage.optional-text-2-1", "mypage.optional-text-2-2"],
  C: ["mypage.optional-text-3-1"]
};

export default {
  beforeMount() {
    this.query = this.$route.query;
    if(!this.query.slug || !this.query.mypage)return this.$router.replace({ path: "/error-404" });
    this.checkMaintenanceMode(this.query);
    this.languages = languageMaps.universal;
    this.autoSetLanguage();
  },
  computed: {
    ...mapState("checkin", ["facility", "loading"]),
    ...mapGetters("checkin", ["facilityName"]),
    locale() {
      return this.$i18n.locale;
    },
    sortedLinks() {
      const visibleLinks = this.facilityLinks.filter(link => link.visibility === 1);
      visibleLinks.forEach((link, index) => {
        link.display_order = index + 1; 
      });
      return visibleLinks.map(link => ({
          ...link,
          icon: this.getIconPath(link.label, link.display_order),
        }));
    },
  },
  mixins: [ scrollers, translation ],
  data() {
    return {
      myPage: {},
      qrData: null,
      myPageA: "",
      myPageB: "",
      myPageC: "",
      showModal: false,
      query: {},
      facilityData: null,
      facilityLinks: [],
      isLoading: false,
      langloading: false,
      languages: {},
      languageCodeSupport: ["ja"],
      termsAndConditions: ""
    };
  },
  async mounted() {
    this.scrollToTop();
    await this.fetchData();
  },

  methods: {
    navigateTo(url) {
      window.open(url, '_blank');
    },
    applyRedirect() {
      if (!redirectDomainFrom || !redirectDomainTo) return;
      const {host, protocol, search} = window.location;
      if (host == redirectDomainFrom) {
        const redirectToUrl = `${protocol}//${redirectDomainTo}/check-in${search}`;
        top.location = redirectToUrl;
      }
    },
    changeLanguage(code) {
      this.$i18n.locale = code;

    },
    async getLanguageSupport(facilityId) {
      try {
        this.langloading = true;
        const response = await settingsApi.getLanguages(facilityId, true);
        const languages = response.data[0].value;
        const codeSupport = [];
        for (let language of languages) codeSupport.push(language.code);
        this.languageCodeSupport = codeSupport;

        this.autoSetLanguage(codeSupport, 'ja');

        this.langloading = false;
      } catch (e) {
        this.$toast.error(this.$("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },
    async showTerms() {
      try {
        if (response.total > 0) {
          this.termsAndConditions = response.data[0].value.content;
        }
        this.$bvModal.show("terms_modal");
      } catch (e) {
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },
    async checkMaintenanceMode(query) {
      let facilityData = null;
      try {
        const response = await facilitiesApi.getBySlug(query.slug, true);
        if (response.data.length < 1) {
          return this.$router.replace({ path: "/error-404" });
        }
        facilityData = response.data[0];
        this.facilityId = facilityData.id
        $store.commit("checkin/update_facility", facilityData);


        await this.getLanguageSupport(facilityData.id);
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("check-in-form.error-generic"), {
          position: "top"
        });
        return;
      }
      const maintenance = this.isMaintenanceMode(facilityData);
      if (maintenance) {
        return this.$router.replace({ path: "/error-503" });
      }
    },
    isMaintenanceMode(facilityData) {
      const settings = facilityData.facility_setting ?? null;
      if (!settings) return false;
      const mode = settings.find(setting => (setting.name === 'maintenance_mode'));
      const value = mode ? (mode.value ?? 0) : 0;
      return value > 0;
    },

    async fetchData() {
      this.isLoading = true;
      const slugName = this.$route.query.slug;
      const myPageId = this.$route.query.mypage;

      try {
        const response = await myPageApi.generateMyPageDate(slugName, myPageId);
        this.myPage = response.data;
        await this.fetchMyPageSettings(this.facilityId);
        await this.fetchFacilityLinks(this.facilityId);
      } catch (e) {
        console.error(e.message);
        if (e.response) {
          if (e.response.status === 404) {
            this.$router.replace({ path: '/error-404' });
          }
          if (e.response.status === 422) {
            if (e.response.data.status.message === 'Reservation expired') {
              const errorMessage = "checkin-expired";
              return this.$router.replace({ path: "/error-422", query: { status: errorMessage } });
            }
          }
        }
      }finally{
        this.isLoading = false
      }
    },

    async fetchFacilityLinks(facilityId) {
      const lang = this.$i18n.locale
      try {
        const response = await iconApi.getIcons(facilityId);
        const optionIcons = response.filter(link =>
          link.label.startsWith('option_')
        );
        const regularIcons = response.filter(link =>
          link.language === lang && !link.label.startsWith('option_')
        );
        this.facilityLinks = regularIcons.concat(optionIcons);
        this.facilityLinks.sort((a, b) => a.display_order - b.display_order);
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },

    async fetchMyPageSettings(facilityId) {
      try {
        const lang = this.locale;
        const myPageAResponse = await settingsApi.getMyPageA(facilityId, lang, true);
        this.myPageA = this.resolveMyPageMessage(myPageAResponse, lang, "A");
        const myPageBResponse = await settingsApi.getMyPageB(facilityId, lang, true);
        this.myPageB = this.resolveMyPageMessage(myPageBResponse, lang, "B");
        const myPageCResponse = await settingsApi.getMyPageC(facilityId, lang, true);
        this.myPageC = this.resolveMyPageMessage(myPageCResponse, lang, "C");
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },
    resolveMyPageMessage(response, lang, key) {
      const value = response.data && response.data.length > 0
        ? response.data[0].value
        : "";

      if (value) return value;
      const separator = this.getDefaultMessageSeparator(lang);
      const defaultMessage = (defaultMessageKeys[key] || [])
        .map((messageKey) => this.$i18n.t(messageKey, lang))
        .join(separator);
      return defaultMessage;
    },
    getDefaultMessageSeparator(lang) {
      if (lang === "en") return " ";
      return "";
    },

    getIconPath(label, display_order) {
      const imgContext = require.context('@/assets/img', false, /\.(svg)$/);
      const isMobile = window.innerWidth < 600;
      const suffix = isMobile
        ? (display_order % 2 === 0 ? 'even' : 'odd')
        : (Math.floor(display_order / 2) % 2 === 0 ? ((display_order % 2 === 0) ? 'even' : 'odd') : ((display_order % 2 === 0) ? 'odd' : 'even'));

      const fileName = (() => {
        switch (label) {
          case 'congestion_status_large_bath': return `onsen_${suffix}.svg`;
          case 'congestion_status_laundry': return `congestion-status-laundry_${suffix}.svg`;
          case 'congestion_status_dining_hall': return `congestion-status-dining-hall_${suffix}.svg`;
          case 'intercom': return `intercom_${suffix}.svg`;
          case 'inquiry': return `inquiry_${suffix}.svg`;
          case 'wifi': return `wifi_${suffix}.svg`;
          case 'tourist_information': return `tourist-information_${suffix}.svg`;
          case 'food_information': return `food-information_${suffix}.svg`;
          case 'official_website': return `official-website_${suffix}.svg`;
          default: return '';
        }
      })();
      return fileName ? imgContext(`./${fileName}`) : "";
    },


  },
  enlargeQRCode() {
    this.qrCodeSize = '150%';
  },

  watch: {
    locale: {
      immediate: true,
      handler() {
        this.fetchData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";

#language_select {
  min-width: $btn-min;
}
.loading-container {
  padding-bottom: 300%;
}
.accordion-card {
  .controls {
    position: absolute;
    right: 0;
    top: 0;
  }
  .btn:focus {
    box-shadow: none !important;
  }
  .body-wrapper {
      padding: 1.5rem;
  }
  &.collapsed {
    .toggle-icon {
      transform: rotate(-180deg);
    }
    .card-header {
      border-bottom: none !important;
    }
    .card-body {
      max-height: 0;
    }
  }
}
.qr-button-container {
  width: fit-content; 
  margin: 0 auto; 
  text-align: center;

  .btn {
    width: auto;
    min-width: 120px;
    height: 30px;
    font-size: 13px;
    border-radius: 5px;
    padding: 0 16px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.aspect-ratio {
  width: 100%;
  position: relative;
  &.ratio-5x3 {
    padding-top: 60%;
  }
}
.container-index{
  background-color: #E9E9E9;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 24px;
  padding-bottom: 5%;
}

p {
  font-size: 14px;
  color: #333;
}

.text-one{
  font-weight: bold;
  text-align: center;
  margin: 24px 40px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.card{
  margin: 24px auto;
  background-color: #fff;
  border-radius: 10px;
  width: 100%;
  padding: 0 32px;
}

.title{
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 0px;
  white-space: normal;
}

.checkin{
  display: flex;
  font-weight: bold;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 12px;
}

.checkin img,
.checkout img{
  width: 23px;
  margin-right: 10px;
}

.checkin span,
.checkout span{
  display: block;
  text-align: right;
  margin-left: auto;
}

.checkout{
  display: flex;
  font-weight: bold;
  width: 100%;
  margin-bottom: 20px;
}

.qr-instruction {
  display: flex;
  font-weight: bold;
  width: 100%;
  margin-bottom: 5px;
}

.qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;
}

.qr-section {
  width: 100%;
}

.qr-code {
  width: 100%;
  max-width: 350px;
}

.zoom img{
  width: 32px;
  height: 32px;
}

.qr-text{
  text-align: left;
  margin-top: 24px;
  margin-bottom: 40px;
}

.cancel-text{
  text-align: left;
  margin-top: 24px;
  margin-bottom: 40px;
}

.buttons {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  gap: 12px;
  margin: 24px auto;
}

.btn {
  justify-content: end;
  align-items: center;
  font-weight: bold;
  width: 100%;
  height: 130px;
  border-radius: 10px;
  overflow: hidden;
}

.btn-text-filter{
  width: fit-content;
  margin-bottom: 0px;
  border-radius: 20px;
  max-width: 200px;
  max-height: 65px;
  padding: 8px 16px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.buttons p {
  text-align: end;
  font-size: 14px;
  font-weight: bold;
  box-sizing: content-box;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  width: auto;
  height: auto;
  z-index: 3;
  margin-bottom: 0;
}

.btn-filter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  outline-offset: -4px;
  border-radius: 10px;
}

button:nth-of-type(odd) .btn-filter {
  background-color: rgba(84, 104, 161, 0.2);
  outline : 1px solid #FFFFFF;
}

button:nth-of-type(even) .btn-filter {
  background-color: rgba(255, 255, 255, 0.4);
  outline : 1px solid #5468a1;
}

.buttons .btn:nth-child(odd) {
  background-color: #5468a1;
}

.buttons .btn:nth-child(even) {
  background-color: #fff;
}

.custom-svg {
  width: 66px;
  height: 66px;
}

hr{
  background-color: #5468a1;
}

.top{
  margin-top: 36px;
}

.text-two{
  text-align: center;
  margin: 16px 18px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.text-three{
  text-align: center;
  margin: 16px 18px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.text-three-pc {
  display: none;
}

.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: rgba(0, 0, 0, 0);
  padding: 20px;
  position: relative;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.enlarged-qr-code {
  width: 90%;
  max-width: 600px;
}

.close-btn {
  position: absolute;
  top: 0px;
  right: 35px;
  font-size: 40px;
  font-weight: 300;
  color: rgb(255, 255, 255);
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
}

.checkin-pc{
  display: none;
}

.checkout-pc{
  display: none;
}

.custom-img-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 40px 25px;
}

.custom-img-container img {
  width: 30%;
  max-height: 260%;
}

.custom-img-container-add {
  position: relative;
  width: 100%;
  display: contents;
  height: 100%;
  padding: 40px;
}

.custom-img {
  width: 100%;
}
.custom-img-add {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btn-text-overlay {
  width: fit-content;
  margin-bottom: 0px;
  border-radius: 20px;
  max-width: 250px;
  max-height: 66px;
  padding: 9px 0px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  margin-left: auto;
}

.btn-text-overlay-add {
  width: fit-content;
  margin-bottom: 0px;
  border-radius: 20px;
  max-width: 250px;
  max-height: 66px;
  padding: 9px 18px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  margin-right: 20px;
}

.buttons .btn:nth-of-type(odd) .btn-text-overlay {
  background-color: rgba(84, 104, 161, 0.6);
}

.buttons .btn:nth-of-type(odd) .btn-text-overlay p {
  color: #fff;
}

.buttons .btn:nth-of-type(even) .btn-text-overlay {
  background-color: rgba(255, 255, 255, 0.9);
}

.buttons .btn:nth-of-type(even) .btn-text-overlay p {
  color: #5468a1;
}

.buttons .btn:nth-of-type(odd) .btn-text-overlay-add {
  background-color: rgba(84, 104, 161, 0.6);
}

.buttons .btn:nth-of-type(odd) .btn-text-overlay-add p {
  color: #fff;
}

.buttons .btn:nth-of-type(even) .btn-text-overlay-add {
  background-color: rgba(255, 255, 255, 0.9);
}

.buttons .btn:nth-of-type(even) .btn-text-overlay-add p {
  color: #5468a1;
}

@media only screen and (min-width: 600px) {

  .container-index {
    padding-right: 150px;
    padding-left: 150px;
    padding-top: 62px;
    padding-bottom: 5%;
  }
  .loading-container{
    padding-bottom: 300%
  }
  .zoom {
    display: none;
  }

  p {
    font-size: 16px;
  }

  .qr-button-container {
  width: 100%;
  max-width: 120px; 
  margin: 0 auto; 
  text-align: center;
  display: none;

    .btn {
      width: 100%;
      height: 30px;
      font-size: 13px;
      border-radius: 5px;
      display: none;
    }
  }

  .qr-instruction {
    display: none;
  }

  .text-one{
    margin: 40px 92px;
  }

  .card{
    padding: 60px 40px;
  }

  .pc-card-content{
    display: flex;
    justify-content: center;
    gap: 40px;
    align-items: center;
  }

  .title{
    display: flex;
    font-size: 48px;
    margin-top: 0px;
    max-width: 385px;
    max-height: 180px;
  }

  .checkin{
    display: none;
  }

  .checkout{
    display: none;
  }

  .qr-container{
    display: flex;
    margin-right: 0px;
  }

  .qr-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 169px;
  }

  .qr-code{
    max-width: 169px;
  }

  .zoom img{
    display: none;
  }

  .qr-text{
    text-align: center;
    margin-top: 40px;
    margin-bottom: 0px;
  }

  .checkin-pc{
    display: flex;
    font-weight: bold;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }

  .checkout-pc{
    display: flex;
    font-weight: bold;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0px;
  }

  .checkin-pc img,
  .checkout-pc img{
    width: 32px;
    margin-right: 40px
  }

  .checkin-pc span {
  display: block;
  text-align: right;
  margin-left: 55px;
  }

  .checkout-pc span{
  display: block;
  text-align: right;
  margin-left: 40px;
  }

  .buttons {
  gap: 20px;
  margin: 45px auto;
  }

  .btn {
    width: calc(50% - 10px);
    height: 120px;
  }

  .btn-text-filter{
    max-width: 232px;
    max-height: 66px;
    padding: 9px 20px;
    margin: 110px;
  }

  .buttons p {
    font-size: 16px;
  }

  .buttons .btn:nth-of-type(4n+1) .btn-text-overlay,
  .buttons .btn:nth-of-type(4n+2) .btn-text-overlay {
    background-color: rgba(84, 104, 161, 0.6);
  }

  .buttons .btn:nth-of-type(4n+1) .btn-text-overlay p,
  .buttons .btn:nth-of-type(4n+2) .btn-text-overlay p {
    color: #fff;
  }

  .buttons .btn:nth-of-type(4n+3) .btn-text-overlay,
  .buttons .btn:nth-of-type(4n+4) .btn-text-overlay {
    background-color: rgba(255, 255, 255, 0.9);
  }

  .buttons .btn:nth-of-type(4n+3) .btn-text-overlay p,
  .buttons .btn:nth-of-type(4n+4) .btn-text-overlay p {
    color: #5468a1;
  }

  .buttons .btn:nth-of-type(4n+1) .btn-text-overlay-add,
  .buttons .btn:nth-of-type(4n+2) .btn-text-overlay-add {
    background-color: rgba(84, 104, 161, 0.6);
  }

  .buttons .btn:nth-of-type(4n+1) .btn-text-overlay-add p,
  .buttons .btn:nth-of-type(4n+2) .btn-text-overlay-add p {
    color: #fff;
  }

  .buttons .btn:nth-of-type(4n+3) .btn-text-overlay-add,
  .buttons .btn:nth-of-type(4n+4) .btn-text-overlay-add {
    background-color: rgba(255, 255, 255, 0.9);
  }

  .buttons .btn:nth-of-type(4n+3) .btn-text-overlay-add p,
  .buttons .btn:nth-of-type(4n+4) .btn-text-overlay-add p {
    color: #5468a1;
  }

  .btn-text-overlay {
    width: fit-content;
    margin-bottom: 0px;
    border-radius: 20px;
    max-width: 250px;
    max-height: 66px;
    padding: 9px 0px;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    margin-left: auto;
  }

  .btn-text-overlay-add {
    width: fit-content;
    margin-bottom: 0px;
    border-radius: 20px;
    max-width: 250px;
    max-height: 66px;
    padding: 9px 18px;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    margin-right: 20px;
  }

  .btn-text-overlay p{
    width: 160%;
  }
  .btn-filter {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    outline-offset: -4px;
    border-radius: 10px;
  }

  button:nth-of-type(4n+1) .btn-filter,
  button:nth-of-type(4n+2) .btn-filter {
    background-color: rgba(84, 104, 161, 0.2);
    outline : 1px solid #FFFFFF;
  }

  button:nth-of-type(4n+3) .btn-filter,
  button:nth-of-type(4n+4) .btn-filter {
    background-color: rgba(255, 255, 255, 0.4);
    outline : 1px solid #5468a1;
  }

  .buttons .btn:nth-child(4n+1),
  .buttons .btn:nth-child(4n+2) {
    background-color: #5468a1;
  }

  .buttons .btn:nth-child(4n+3),
  .buttons .btn:nth-child(4n+4) {
    background-color: #fff;
  }

  .custom-svg {
    width: 70px;
    height: 70px;
  }

  .top{
    margin-top: 15px;
  }

  .text-two{
    margin: 40px 40px;
  }

  .text-three{
    margin: 16px 0 0;
    width: 100%;
    text-align: center;
  }

  .text-three-mobile {
    display: none;
  }

  .text-three-pc {
    display: block;
    margin: 0 40px 40px;
    width: auto;
  }

  .custom-img {
    width: 50px;
    height: auto;
  }

  .custom-img-container {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 40px;
  }

  .custom-img-container img {
    width: 30%;
    max-height: 260%;
  }

  .custom-img-container-add {
  position: relative;
  width: 100%;
  display: contents;
  height: 100%;
  padding: 40px;
  }
}
</style>
